export default __webpack_public_path__ + "static/media/audio.4c635496.svg";